import { Skeleton } from "antd";
import DashboardBadge from "../DashboardBadge";
import { formatAmount, formatPrice } from "../../../utility/helper";
import DashboardPreviewInfo from "../DashboardPreviewInfo";
import { useSelector } from "react-redux";
import useSubscriptionPlans from "../../../hooks/useSubscriptionPlans";

function AccountSummaryPreview() {
  const {
    profile: { profileData, loading },
    pricingPlan: { referralRewardsLoading, referralData },
  } = useSelector((state) => state);

  const totalMoney = referralData?.total_cashable_credit;
  const totalCredit = referralData?.total_credit_reward;

  const { planTitle, hasSubscription } = useSubscriptionPlans();

  return (
    <>
      {loading ? (
        <Skeleton.Input active size="small" />
      ) : (
        <DashboardBadge type="primary">
          {
            <>
              {hasSubscription ? `${planTitle} Account |` : "Account Credit:"}
            </>
          }{" "}
          {`$${formatPrice(profileData?.credit / 100)}`}{" "}
        </DashboardBadge>
      )}
      {referralRewardsLoading ? (
        <Skeleton.Input active size="small" />
      ) : (
        <DashboardPreviewInfo>
          Referrals: {totalCredit && `$${formatAmount(totalMoney)}`}
        </DashboardPreviewInfo>
      )}
    </>
  );
}

export default AccountSummaryPreview;
